import React, { useEffect } from 'react';
import './campos-menu.component.scss';
import { Button, FormControl, FormControlLabel, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { useInput } from '../../hooks/useInput.hook';
import { ItensMenuModel } from '../../models/menu.model';
import Checkbox from '@mui/material/Checkbox';
import DeleteIcon from '@mui/icons-material/Delete';
import { SalvarPainelService } from '../../services/salvar-painel.service';

type CamposMenuProps = {
  setVal: (val: any) => void;
  removeItem: (id?: string) => void;
  itemMenu?: ItensMenuModel;
  itensMenu?: ItensMenuModel[];
  index?: number;
}

function CamposMenuComponent(props: CamposMenuProps) {

  const [nomeInput, setNomeInput] = React.useState(props.itemMenu?.nome);
  const [submenuInput, setSubmenuInput] = React.useState(props.itemMenu?.submenu);
  const { value: nomeMenuInputText, bind: bindNomeMenuInputText, setValue: setNomeMenuInputText } = useInput(props.itemMenu?.nome);
  const { value: idDoComponenteInputText, bind: bindIdDoComponenteInputText, setValue: setIdDoComponenteInputText } = useInput(props.itemMenu?.id_do_componente);
  const { value: palavrasChaveInputText, bind: bindPalavrasChaveInputText, setValue: setPalavrasChaveInputText } = useInput(props.itemMenu?.palavras_chave);
  const { value: descricaoInputText, bind: bindDescricaoInputText, setValue: setDescricaoInputText } = useInput(props.itemMenu?.descricao);
  const [semAcao, setSemAcao] = React.useState<boolean>(props.itemMenu ? props.itemMenu.sem_acao : false);

  SalvarPainelService.getSalvar().subscribe(() => {
    handleChangeItem();
  });

  const handleChangeItem = () => {
    props.setVal({
      nome: nomeMenuInputText,
      id_do_componente: idDoComponenteInputText,
      submenu: submenuInput,
      palavras_chave: palavrasChaveInputText,
      descricao: descricaoInputText,
      sem_acao: semAcao,
      id: props.itemMenu?.id
    });
  };

  return (
    <section className="campos-menu">
      <div className="campo w50">
        <TextField {...bindNomeMenuInputText} label="Nome do menu" />
      </div>

      <div className="campo w50">
        <TextField {...bindIdDoComponenteInputText} label="ID do componente" />
        <p>Apenas caracteres sem acento, sem espaço. Exemplo: (meu-menu-sem-acentuacao)</p>
      </div>

      <div className="campo w50">
        <FormControl sx={{ m: 1, minWidth: 120 }} size="small" className='select'>
          <InputLabel id="demo-select-small-label">Submenu</InputLabel>
          <Select
            labelId="demo-select-small-label"
            id="demo-select-small"
            value={submenuInput}
            label="Submenu"
            onChange={(event) => setSubmenuInput(event.target.value)}
          >
            <MenuItem value="">
              <em>Selelcione</em>
            </MenuItem>
            {
              props.itensMenu?.map((item, iMenu) => (
                <MenuItem key={iMenu} value={item.id_do_componente == '' ? ',' : item.id_do_componente} disabled={nomeInput == item.nome}>{item.nome}</MenuItem>
              ))
            }
          </Select>
        </FormControl>
      </div>

      <div className="campo w50">
        <FormControlLabel
          control={
            <Checkbox defaultChecked={false} onChange={(event) => setSemAcao(event.target.checked)} />
          }
          label="Sem ação?"
        />
      </div>

      <div className="campo w50">
        <TextField rows={3} multiline {...bindPalavrasChaveInputText} label="Palavras-chave" />
        <p>Palavras-chave seperadas com virgula, exemplo: Palavra 01, Palavra 02</p>
      </div>

      <div className="campo w50">
        <TextField rows={3} multiline {...bindDescricaoInputText} label="Meta descrição" />
      </div>

      <div className="bts">
        <Button className='bt remove' onClick={() => props.removeItem(props.itemMenu?.id)}><DeleteIcon /> Remover menu</Button>
      </div>
    </section>
  );
}

export default CamposMenuComponent;
